export default __webpack_public_path__ + "static/media/Q0002.85cfba44.png";